import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
        REGION_ALLOCATION_SUMMARY,
        REGION_DOWNLOAD_EXCEL,
        REGION_MILESTONE_SUMMARY,
        REGION_PROJECT_DATE,
        REGION_PROJECT_LISTING,
        REGION_GET_COMMERCIAL_UNIT,
        REGION_ADD_PACKAGE,
        REGION_ADD_INTIAL_TECC,
        REGION_UPLOAD_EXCEL,
        REGION_GET_INITIAL_TECC,
        REGION_GET_PROJECT_COST,
        REGION_GET_APPORTIONED_COST,
        REGION_GET_OPERATIONAL_INCOME,
        REGION_GET_BILLING_COST,
        REGION_GET_BILLING_ADD_PACKAGE,
        REGION_GET_CASH_INFLOW,
        REGION_GET_CASH_OUTFLOW,
        REGION_GET_PROJECT_REVENUE,
        UNIT_UPLOAD_EXCEL,
        UNIT_DOWNLOAD_EXCEL,
        UNIT_GET_CASH_INFLOW,
        UNIT_GET_CASH_OUTFLOW,
        UNIT_GET_OPERATIONAL_INCOME,
        UNIT_GET_APPORTIONED_COST,
        UNIT_GET_PROJECT_COST,
        UNIT_GET_BILLING,
        REGION_PROJECT_SUMMARY,
        REGION_GET_PROJECT_PROFIT_LOSS,
        UNIT_GET_CUSTOM_CARDS,
        REGION_GET_CUSTOM_CARDS,
        UNIT_PROJECT_SUMMARY,
        UNIT_GET_PROJECT_PROFIT_LOSS,
        UNIT_GET_PROJECT_REVENUE,
        REGION_DELETE_PACKAGES,
        UNIT_DELETE_PRODUCTS,
        UNIT_PROJECT_LISTING,
        REGION_GET_TABLES_UPLOAD_STATUS,
        UNIT_GET_TABLES_UPLOAD_STATUS,
        GET_OPERATING_PERFORMANCE_UPLOAD_STATUS,
        GET_DIRECT_ORDERS_UPLOAD_STATUS,
        GET_IUT_UPLOAD_STATUS,
        SAVE_AS_DRAFT,
        INITIATE_FINAL_SUBMISSION_STATUS,
        GET_ANTICIPATED_ORDERS_UPLOAD_STATUS,
        PROJECT_STATUS,
        GET_OTHER_PROJECTS_UPLOAD_STATUS,
        GET_CUSTOM_CARD,
        DELETE_DIRECT_ORDER,
        DELETE_OTHER_PROJECTS,
        DELETE_IUT,
        EXTENDED_PROJECT_LISTING,
        PMG_UPLOAD_EXCEL,
        PMG_DOWNLOAD_EXCEL,
        PMG_MILESTONE_DOWNLOAD_EXCEL,
        PMG_MILESTONE_UPLOAD_EXCEL,
        PMG_MILESTONE_MAPPING_DOWNLOAD_EXCEL,
        PMG_MILESTONE_MAPPING_UPLOAD_EXCEL,
        UNIT_GET_CUSTOM_CARDS_VERSIONED,
        REGION_GET_CUSTOM_CARDS_VERSIONED,
        UNIT_GET_PROJECT_REVENUE_VERSIONED,
        REGION_GET_PROJECT_REVENUE_VERSIONED,
        UNIT_GET_PROJECT_COST_VERSIONED,
        UNIT_GET_PROJECT_PROFIT_LOSS_VERSIONED,
        REGION_GET_PROJECT_PROFIT_LOSS_VERSIONED,
        REGION_GET_PROJECT_COST_VERSIONED,
        UNIT_GET_CASH_INFLOW_VERSIONED,
        REGION_GET_CASH_INFLOW_VERSIONED,
        REGION_GET_CASH_OUTFLOW_VERSIONED,
        UNIT_GET_CASH_OUTFLOW_VERSIONED,
        UNIT_GET_APPORTIONED_COST_VERSIONED,
        UNIT_GET_OPERATIONAL_INCOME_VERSIONED,
        REGION_GET_OPERATIONAL_INCOME_VERSIONED,
        UNIT_GET_BILLING_VERSIONED,
        REGION_GET_BILLING_COST_VERSIONED,
        UNIT_PROJECT_SUMMARY_VERSIONED,
        REGION_PROJECT_SUMMARY_VERSIONED,
        GET_CUSTOM_CARD_VERSIONED,
} from '../../api/endpoints';
import openNotification from '../../components/Common/OpenNotification';
import axiosInstance from '../../utils/axiosInstance';
import { RemoveEmptyKey } from '../../utils/removeEmptyKey';

const initialState = {
        activeStep: 1,
        disableProceed: false,
        projectListData: [],
        projectDates: {},
        billingCost: [],
        billingCostVersion: [],

        billingCostCompleteData: {},
        billingCostCompleteDataVersion: {},
        
        ioNumber: '',
        revNumber: '',
        milestoneSummary: [],
        allocationSummary: [],
        totalPagesProjectListing: 0,
        ioHeadsData: [],
        getInitialValue: {},
        AC: [],
        PC: [],
        OI: [],
        B: [],
        projectCostCompleteData: {},
        projectCostData: [],
        apportionedCostData: [],
        operationalIncomeData: [],
        apportionedCostCompleteData: {},
        cashInflowData: [],
        cashOutflowData: [],
        projectRevenueData: {},
        loading: false,
        projectSummary: [],
        profitLossData: [],
        cardData: {},
        cardDataLoading: false,
        uploadTablesStatus: {},
        finalSubmissionStatus: {},
        projectStatus: {},
        extendedProjectListing: [],
};

export const fetchRegionProjectListing = createAsyncThunk('region/projectListing', async ({ page = 1, pageSize = 10, search, unitType, mnfUnit, bsUnit }, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const url = unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_PROJECT_LISTING : REGION_PROJECT_LISTING;

                const payload = !!mnfUnit
                        ? RemoveEmptyKey({
                                  page: page,
                                  limit: pageSize,
                                  search: search,
                                  MNF_UNIT: mnfUnit,
                                  bs_unit: bsUnit,
                          })
                        : { page: page, limit: pageSize, search: search };

                const response = await axiosInstance.get(url, {
                        params: { ...payload },
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchRegionProjectDates = createAsyncThunk('region/projectDates', async ({ ioNo, revNo, mnfUnit }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: ioNo,
                        REV_NO: revNo,
                        MNF_UNIT: mnfUnit,
                });

                const response = await axiosInstance.get(REGION_PROJECT_DATE, {
                        params: payload,
                });
                return response?.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getExtendedProjectListing = createAsyncThunk('region/getExtendedProjectListing', async ({ mnfUnit }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        MNF_UNIT: mnfUnit,
                });
                const response = await axiosInstance.get(EXTENDED_PROJECT_LISTING, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchRegionProjectSummary = createAsyncThunk('region/projectSummary', async ({ ioNo, revNo, mnfUnit, unitType }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: ioNo,
                        REV_NO: revNo,
                        MNF_UNIT: mnfUnit,
                });

                const ROLE = sessionStorage.getItem('role');

                const url = unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_PROJECT_SUMMARY : REGION_PROJECT_SUMMARY;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response?.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const fetchRegionProjectSummaryVersioned = createAsyncThunk('region/projectSummaryVersion', async ({ ioNo, revNo, mnfUnit, unitType,version }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: ioNo,
                        REV_NO: revNo,
                        MNF_UNIT: mnfUnit,
                        version: version,
                });

                const ROLE = sessionStorage.getItem('role');

                const url = unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_PROJECT_SUMMARY_VERSIONED : REGION_PROJECT_SUMMARY_VERSIONED;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response?.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchRegionAllocationSummary = createAsyncThunk('region/allocationSummary', async ({ ioNo, revNo, mnfUnit }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: ioNo,
                        REV_NO: revNo,
                        MNF_UNIT: mnfUnit,
                });
                const response = await axiosInstance.get(REGION_ALLOCATION_SUMMARY, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchRegionMilestoneSummary = createAsyncThunk('region/io-allocation_detail', async ({ ioNo, revNo, mnfUnit }, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: ioNo,
                        // REV_NO: revNo,
                        MNF_UNIT: mnfUnit,
                });

                const response = await axiosInstance.get(REGION_MILESTONE_SUMMARY, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const fetchDownloadExcel = createAsyncThunk('region/downloadExcel', async ({ fileType, ioNo, revNo, version = 0, unitType = null, mnfUnit = null }, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');
                const effectiveRole = ROLE === 'ADMIN' && unitType ? unitType : ROLE;
                const apiUrl = effectiveRole === 'UNIT' ? UNIT_DOWNLOAD_EXCEL && UNIT_DOWNLOAD_EXCEL[fileType?.toLowerCase()] : REGION_DOWNLOAD_EXCEL && REGION_DOWNLOAD_EXCEL[fileType?.toLowerCase()];

                if (!apiUrl) throw new Error('Invalid file type or role');

                const requestData = {
                        IO_NO: ioNo,
                        REV_NO: revNo,
                };

                if (version !== 0) {
                        requestData.VERSION = version;
                }
                if (mnfUnit) {
                        requestData.MNF_UNIT = mnfUnit;
                }

                const response = await axiosInstance.post(apiUrl, requestData, {
                        responseType: 'blob',
                });

                // Capitalize each word in fileType for consistency
                const formattedFileType = fileType
                        .replace(/_/g, ' ')
                        .replace(/\b\w/g, (char) => char.toUpperCase())
                        .replace(/ /g, '_');

                const filename = ioNo ? `${ioNo}_${formattedFileType}.xlsx` : `${formattedFileType}.xlsx`;

                const blob = new Blob([response.data], {
                        type: response.data.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        } catch (error) {
                openNotification('error', 'Download Failed', error.message || 'Something went wrong.');
                return rejectWithValue(error.message || 'Something went wrong.');
        }
});

export const fetchDownloadExcelForAdmin = createAsyncThunk('pmg/downloadExcelForAdmin', async (fileName, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');
                const fileType = fileName.replace('.csv', '').replace(/ /g, '_');
                if (ROLE !== 'ADMIN') {
                        openNotification('error', 'Forbidden', 'Only ADMIN can download this file');
                        return rejectWithValue('Forbidden');
                }

                const apiUrl = fileType === 'Project' ? PMG_DOWNLOAD_EXCEL && PMG_DOWNLOAD_EXCEL['project'] : fileType === 'project_milestone' ? PMG_MILESTONE_DOWNLOAD_EXCEL && PMG_MILESTONE_DOWNLOAD_EXCEL['project_milestone'] : fileType === 'project_milestone_mapping' ? PMG_MILESTONE_MAPPING_DOWNLOAD_EXCEL && PMG_MILESTONE_MAPPING_DOWNLOAD_EXCEL['project_milestone_mapping'] : null;

                if (!apiUrl) throw new Error('Invalid Url');
                if (!apiUrl) {
                        openNotification('error', 'Download Failed', 'Download endpoint not configured');
                        return rejectWithValue('Download endpoint not configured');
                }

                const response = await axiosInstance.get(apiUrl, {
                        responseType: 'blob',
                });
                const mime = response && response.type ? response.type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                const blob = new Blob([response.data], { type: mime });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                const downloadName = fileName && fileName.toString().length ? (fileName.toString().includes('.') ? fileName.toString().replace(/\.[^/.]+$/, '.xlsx') : `${fileName.toString()}.xlsx`) : 'download.xlsx';
                link.download = downloadName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
        } catch (error) {
                openNotification('error', 'Download Failed', error.message || 'Something went wrong.');
                return rejectWithValue(error.message || 'Something went wrong.');
        }
});

export const uploadExcelData = createAsyncThunk('region/uploadExcelData', async ({ ioNo, revNo, fileType, data }, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');
                const apiUrl = ROLE === 'UNIT' ? UNIT_UPLOAD_EXCEL[fileType?.toLowerCase()] : REGION_UPLOAD_EXCEL[fileType?.toLowerCase()];
                if (!apiUrl) throw new Error('Invalid file type');

                const response = await axiosInstance.post(apiUrl, {
                        data,
                });

                openNotification('success', 'Upload Successful', `${fileType} uploaded successfully.`);
                return response.data;
        } catch (error) {
                openNotification('error', 'Upload Failed', error.message || 'Something went wrong.');
                return rejectWithValue(error.message || 'Something went wrong.');
        }
});

export const uploadPmgProjectsBulk = createAsyncThunk('region/uploadPmgProjectsBulk', async ({ data, fileType }, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');
                if (ROLE !== 'ADMIN') throw new Error('Only ADMIN can upload PMG projects bulk');

                const apiUrl = ROLE === 'ADMIN' && fileType === 'Project' ? PMG_UPLOAD_EXCEL[fileType?.toLowerCase()] : ROLE === 'ADMIN' && fileType === 'project_milestone' ? PMG_MILESTONE_UPLOAD_EXCEL[fileType?.toLowerCase()] : ROLE === 'ADMIN' && fileType === 'project_milestone_mapping' ? PMG_MILESTONE_MAPPING_UPLOAD_EXCEL[fileType?.toLowerCase()] : null;

                const response = await axiosInstance.post(apiUrl, data);

                openNotification('success', 'Upload Successful', 'File uploaded successfully.');
                return response.data;
        } catch (error) {
                openNotification('error', 'Upload Failed', error?.response?.data?.message || error.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || error.message || 'Something went wrong.');
        }
});

export const fetchUnitCommercialOptions = createAsyncThunk('region/fetchUnitCommercialOptions', async (_, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(REGION_GET_COMMERCIAL_UNIT);
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const checkTablesUploadStatus = createAsyncThunk('region/checkTablesUploadStatus', async ({ IO_NO, REV_NO, flowName = '' }, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                if (flowName === 'operatingPerformance') {
                        // If flowName is present, hit different API
                        const response = await axiosInstance.get(GET_OPERATING_PERFORMANCE_UPLOAD_STATUS);
                        return response.data;
                } else if (flowName === 'directOrders') {
                        const response = await axiosInstance.get(GET_DIRECT_ORDERS_UPLOAD_STATUS);
                        return response.data;
                } else if (flowName === 'iut') {
                        const response = await axiosInstance.get(GET_IUT_UPLOAD_STATUS);
                        return response.data;
                } else if (flowName === 'anticipatedOrders') {
                        const response = await axiosInstance.get(GET_ANTICIPATED_ORDERS_UPLOAD_STATUS);
                        return response.data;
                } else if (flowName === 'otherProjects') {
                        const response = await axiosInstance.get(GET_OTHER_PROJECTS_UPLOAD_STATUS);
                        return response.data;
                } else {
                        // Fallback to default behavior
                        const apiUrl = ROLE === 'UNIT' ? UNIT_GET_TABLES_UPLOAD_STATUS : REGION_GET_TABLES_UPLOAD_STATUS;
                        const response = await axiosInstance.get(apiUrl, {
                                params: {
                                        IO_NO,
                                        REV_NO,
                                },
                        });
                        return response.data;
                }
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

// Add Package
// Add Package
export const addPackage = createAsyncThunk('region/addPackage', async (packageData, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(REGION_ADD_PACKAGE, packageData);

                if (response.status === 200) {
                        dispatch(
                                getProjectCost({
                                        IO_NO: packageData?.IO_NO,
                                        REV_NO: packageData?.REV_NO,
                                }),
                        );
                }

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
// Add Package to ill
export const addPackageBill = createAsyncThunk('region/addPackage', async (packageData, { dispatch, rejectWithValue }) => {
        try {
                const response = await axiosInstance.post(REGION_GET_BILLING_ADD_PACKAGE, packageData);

                if (response.status === 200) {
                        dispatch(
                                getBillingCost({
                                        IO_NO: packageData?.IO_NO,
                                        REV_NO: packageData?.REV_NO,
                                }),
                        );
                }

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const createInitialEstimate = createAsyncThunk('region/createInitialEstimate', async (estimateData, { rejectWithValue }) => {
        const payload = {
                IO_NO: estimateData?.IO_NO,
                REV_NO: estimateData?.REV_NO,
                ...(estimateData?.PROJ_COST_TECC ? { PROJ_COST_TECC: estimateData.PROJ_COST_TECC } : { APORTION_COST: estimateData?.APORTION_COST }),
        };
        try {
                const response = await axiosInstance.post(REGION_ADD_INTIAL_TECC, payload);
                if (response.status === 200) {
                        openNotification('info', 'Initial estimate', `${estimateData?.APORTION_COST ? 'Initial estimate for Apportioned Cost has been updated' : 'Initial estimate for Project Cost TECC has been updated'}`);
                }
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getInitialEstimate = createAsyncThunk('region/getInitialEstimate', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(REGION_GET_INITIAL_TECC, {
                        params: {
                                IO_NO: params?.IO_NO,
                                REV_NO: params?.REV_NO,
                        },
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getProjectCost = createAsyncThunk('region/getProjectCost', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                });
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_COST  : REGION_GET_PROJECT_COST;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getProjectCostVersion = createAsyncThunk('region/getProjectCostVersion', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_COST_VERSIONED : REGION_GET_PROJECT_COST_VERSIONED;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getFinalSubmissionStatus = createAsyncThunk('region/getFinalSubmissionStatus', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.get(INITIATE_FINAL_SUBMISSION_STATUS);
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getProjectStatus = createAsyncThunk('region/getProjectStatus', async ({ mnfUnit }, { rejectWithValue }) => {
        try {
                console.log('mnf');
                const payload = RemoveEmptyKey({
                        MNF_UNIT: mnfUnit,
                });

                const response = await axiosInstance.get(PROJECT_STATUS, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getBillingCost = createAsyncThunk('region/getBillingCost', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                });
                const ROLE = sessionStorage.getItem('role');
                const apiUrl = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_BILLING : REGION_GET_BILLING_COST;
                const response = await axiosInstance.get(apiUrl, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getBillingCostVersioned = createAsyncThunk('region/getBillingCostVersioned', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });
                const ROLE = sessionStorage.getItem('role');
                const apiUrl = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_BILLING_VERSIONED : REGION_GET_BILLING_COST_VERSIONED;
                const response = await axiosInstance.get(apiUrl, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getCashInflowData = createAsyncThunk('region/getCashInflowData', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                });
                const role = sessionStorage.getItem('role');
                const endpoint = params?.unitType === 'UNIT' || role === 'UNIT' ? UNIT_GET_CASH_INFLOW : REGION_GET_CASH_INFLOW;
                const response = await axiosInstance.get(endpoint, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                const errorMessage = error?.response?.data?.message || 'Something went wrong.';
                openNotification(errorMessage);
                return rejectWithValue(errorMessage);
        }
});
export const getCashInflowDataVersion = createAsyncThunk('region/getCashInflowDataVersion', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });
                const role = sessionStorage.getItem('role');
                const endpoint = params?.unitType === 'UNIT' || role === 'UNIT' ? UNIT_GET_CASH_INFLOW_VERSIONED : REGION_GET_CASH_INFLOW_VERSIONED;
                const response = await axiosInstance.get(endpoint, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                const errorMessage = error?.response?.data?.message || 'Something went wrong.';
                openNotification(errorMessage);
                return rejectWithValue(errorMessage);
        }
});

export const getCashOutflowData = createAsyncThunk('region/getCashOutflowData', async (params, { rejectWithValue }) => {
        try {
                const role = sessionStorage.getItem('role');

                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                });
                const endpoint = params?.unitType === 'UNIT' || role === 'UNIT' ? UNIT_GET_CASH_OUTFLOW : REGION_GET_CASH_OUTFLOW;
                const response = await axiosInstance.get(endpoint, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                const errorMessage = error?.response?.data?.message || 'Something went wrong.';
                openNotification(errorMessage);
                return rejectWithValue(errorMessage);
        }
});
export const getCashOutflowDataVersioned = createAsyncThunk('region/getCashOutflowDataVersioned', async (params, { rejectWithValue }) => {
        try {
                const role = sessionStorage.getItem('role');

                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });
                const endpoint = params?.unitType === 'UNIT' || role === 'UNIT' ? UNIT_GET_CASH_OUTFLOW_VERSIONED : REGION_GET_CASH_OUTFLOW_VERSIONED;
                const response = await axiosInstance.get(endpoint, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                const errorMessage = error?.response?.data?.message || 'Something went wrong.';
                openNotification(errorMessage);
                return rejectWithValue(errorMessage);
        }
});

export const getApportionedCost = createAsyncThunk('region/getApportionedCost', async (params, { rejectWithValue }) => {
        const payload = RemoveEmptyKey({
                IO_NO: params?.ioNo || params.IO_NO,
                REV_NO: params?.revNo || params.REV_NO,
                MNF_UNIT: params?.mnfUnit,
        });
        const ROLE = sessionStorage.getItem('role');

        const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_APPORTIONED_COST : REGION_GET_APPORTIONED_COST;
        try {
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getApportionedCostVersioned = createAsyncThunk('region/getApportionedCostVersioned', async (params, { rejectWithValue }) => {
        const payload = RemoveEmptyKey({
                IO_NO: params?.ioNo || params.IO_NO,
                REV_NO: params?.revNo || params.REV_NO,
                MNF_UNIT: params?.mnfUnit,
                version: params?.version,
        });
        const ROLE = sessionStorage.getItem('role');

        const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_APPORTIONED_COST_VERSIONED : REGION_GET_APPORTIONED_COST;
        try {
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getProjectRevenue = createAsyncThunk('region/getProjectRevenue', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo,
                        REV_NO: params?.revNo,
                        MNF_UNIT: params?.mnfUnit,
                });
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_REVENUE : REGION_GET_PROJECT_REVENUE;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getProjectRevenueVersion = createAsyncThunk('region/getProjectRevenueVersion', async (params, { rejectWithValue }) => {
        try {
                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo,
                        REV_NO: params?.revNo,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_REVENUE_VERSIONED : REGION_GET_PROJECT_REVENUE_VERSIONED;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getProfitLoss = createAsyncThunk('region/getProfitLoss', async (params, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                });

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_PROFIT_LOSS : REGION_GET_PROJECT_PROFIT_LOSS;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getProfitLossVersion = createAsyncThunk('region/getProfitLossVersion', async (params, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const payload = RemoveEmptyKey({
                        IO_NO: params?.ioNo || params?.IO_NO,
                        REV_NO: params?.revNo || params.REV_NO,
                        MNF_UNIT: params?.mnfUnit,
                        version: params?.version,
                });

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_PROJECT_PROFIT_LOSS_VERSIONED : REGION_GET_PROJECT_PROFIT_LOSS_VERSIONED;
                const response = await axiosInstance.get(url, {
                        params: payload,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getOperationalIncome = createAsyncThunk('region/getOperationalIncome', async (params, { rejectWithValue }) => {
        const payload = RemoveEmptyKey({
                IO_NO: params?.ioNo || params.IO_NO,
                REV_NO: params?.revNo || params.REV_NO,
                MNF_UNIT: params?.mnfUnit,
        });
        const ROLE = sessionStorage.getItem('role');

        const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_OPERATIONAL_INCOME : REGION_GET_OPERATIONAL_INCOME;

        try {
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOperationalIncomeVersioned = createAsyncThunk('region/getOperationalIncomeVersioned', async (params, { rejectWithValue }) => {
        const payload = RemoveEmptyKey({
                IO_NO: params?.ioNo || params.IO_NO,
                REV_NO: params?.revNo || params.REV_NO,
                MNF_UNIT: params?.mnfUnit,
                version: params?.version,
        });
        const ROLE = sessionStorage.getItem('role');

        const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_OPERATIONAL_INCOME_VERSIONED : REGION_GET_OPERATIONAL_INCOME_VERSIONED;

        try {
                const response = await axiosInstance.get(url, {
                        params: payload,
                });
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getCustomCardDetail = createAsyncThunk('region/getCustomCardDetail', async (params, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_CUSTOM_CARDS : REGION_GET_CUSTOM_CARDS;
                const queryParams = {
                        IO_NO: params?.ioNo,
                        REV_NO: params?.revNo,
                };

                // Add month range as 4 individual parameters
                if (params?.monthRange) {
                        const { from_month, from_year, to_month, to_year } = params.monthRange;
                        if (from_month) queryParams.from_month = from_month;
                        if (from_year) queryParams.from_year = from_year;
                        if (to_month) queryParams.to_month = to_month;
                        if (to_year) queryParams.to_year = to_year;
                }

                if (params?.mnfUnit) {
                        queryParams.MNF_UNIT = params.mnfUnit;
                }

                if (params?.INCLUDE_IUT) {
                        queryParams.INCLUDE_IUT = true;
                }

                const response = await axiosInstance.get(url, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getCustomCardDetailVersion = createAsyncThunk('region/getCustomCardDetailVersion', async (params, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const url = params?.unitType === 'UNIT' || ROLE === 'UNIT' ? UNIT_GET_CUSTOM_CARDS_VERSIONED : REGION_GET_CUSTOM_CARDS_VERSIONED;
                const queryParams = {
                        IO_NO: params?.ioNo,
                        REV_NO: params?.revNo,
                        version: params?.version,
                };

                // Add month range as 4 individual parameters
                if (params?.monthRange) {
                        const { from_month, from_year, to_month, to_year } = params.monthRange;
                        if (from_month) queryParams.from_month = from_month;
                        if (from_year) queryParams.from_year = from_year;
                        if (to_month) queryParams.to_month = to_month;
                        if (to_year) queryParams.to_year = to_year;
                }

                if (params?.mnfUnit) {
                        queryParams.MNF_UNIT = params.mnfUnit;
                }

                const response = await axiosInstance.get(url, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const getOtherFlowsCustomCardDetail = createAsyncThunk('region/getOtherFlowsCustomCardDetail', async (params, { rejectWithValue }) => {
        try {
                const url = GET_CUSTOM_CARD[params.flowName];

                // Add month range as 4 individual parameters
                const queryParams = {};
                if (params?.monthRange) {
                        const { from_date, to_date } = params.monthRange;
                        if (from_date) queryParams.from_date = from_date;
                        if (to_date) queryParams.to_date = to_date;
                }

                if (params.mnfUnit) queryParams.MNF_UNIT = params?.mnfUnit;
                const response = await axiosInstance.get(url, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});
export const getOtherFlowsCustomCardDetailVersioned = createAsyncThunk('region/getOtherFlowsCustomCardDetailVersioned', async (params, { rejectWithValue }) => {
        try {
                const url = GET_CUSTOM_CARD_VERSIONED[params.flowName];

                // Add month range as 4 individual parameters
                const queryParams = {};
                if (params?.monthRange) {
                        const { from_date, to_date } = params.monthRange;
                        if (from_date) queryParams.from_date = from_date;
                        if (to_date) queryParams.to_date = to_date;
                }

                if (params.mnfUnit) queryParams.MNF_UNIT = params?.mnfUnit;
                queryParams.version = params?.version;
                const response = await axiosInstance.get(url, {
                        params: queryParams,
                });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const deletePackages = createAsyncThunk('region/deletePackages', async (params, { rejectWithValue }) => {
        try {
                const ROLE = sessionStorage.getItem('role');

                const url = ROLE === 'UNIT' ? `${UNIT_DELETE_PRODUCTS}?type=${params?.type || 'PC'}` : `${REGION_DELETE_PACKAGES}?type=${params?.type || 'PC'}`;

                // Build request body based on ROLE
                const data =
                        ROLE === 'UNIT'
                                ? {
                                          IO_NO: params?.IO_NO,
                                          REV_NO: params?.REV_NO,
                                          HEAD_TYPE: params?.HEAD_TYPE || '01',
                                          PRODUCT_CODE: [params?.PRODUCT_CODE] || [],
                                          PRODUCT_TYPE_CODE: params?.PRODUCT_TYPE_CODE,
                                          COMMERCIAL_CODE: params?.COMMERCIAL_CODE,
                                  }
                                : {
                                          IO_NO: params?.IO_NO,
                                          REV_NO: params?.REV_NO,
                                          HEAD_TYPE: params?.HEAD_TYPE || '01',
                                          PACKAGE_ID: [params?.PACKAGE_ID],
                                          COMMERCIAL_CODE: params?.COMMERCIAL_CODE,
                                  };

                const response = await axiosInstance.delete(url, { data });

                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const deleteDirectOrder = createAsyncThunk('unit/deleteAnticipatedOrder', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.delete(`${DELETE_DIRECT_ORDER}/${params}`);
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const deleteOtherProjects = createAsyncThunk('unit/deleteOtherProjects', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.delete(`${DELETE_OTHER_PROJECTS}/${params}`);
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const deleteIUT = createAsyncThunk('unit/deleteIUT', async (params, { rejectWithValue }) => {
        try {
                const response = await axiosInstance.delete(`${DELETE_IUT}/${params}`);
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

export const saveAsDraft = createAsyncThunk('region/saveAsDraft', async (params, { rejectWithValue }) => {
        try {
                // Build query params dynamically
                const queryParams = {};
                if (params?.IO_NO) queryParams.IO_NO = params.IO_NO;
                if (params?.REV_NO) queryParams.REV_NO = params.REV_NO;
                if (params?.TYPE) queryParams.TYPE = params.TYPE;
                if (params?.PROJECT_TYPE) queryParams.PROJECT_TYPE = params?.PROJECT_TYPE;
                if (params?.MNF_UNIT) queryParams.MNF_UNIT = params?.MNF_UNIT;

                const response = await axiosInstance.post(
                        SAVE_AS_DRAFT,
                        {},
                        {
                                params: queryParams,
                        },
                );
                if(params?.TYPE==="FINAL_SUBMITTED"){
                     window.location.reload();
                }
                return response.data;
        } catch (error) {
                openNotification(error?.response?.data?.message || 'Something went wrong.');
                return rejectWithValue(error?.response?.data?.message || 'Something went wrong.');
        }
});

const budgetSlice = createSlice({
        name: 'budget',
        initialState,
        reducers: {
                setActiveStep: (state, action) => {
                        state.activeStep = action.payload;
                },
                setDisableProceed: (state, action) => {
                        state.disableProceed = action.payload;
                },
                setRevNumber: (state, action) => {
                        state.revNumber = action.payload;
                },
                setIoNumber: (state, action) => {
                        state.ioNumber = action.payload;
                },
                clearProjectDates: (state) => {
                        state.projectDates = {};
                },
        },
        extraReducers: (builder) => {
                builder
                        // Reducer for fetch projects
                        .addCase(fetchRegionProjectListing.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchRegionProjectListing.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectListData = action.payload.data?.data;
                                state.totalPagesProjectListing = action?.payload?.data?.total;
                        })
                        .addCase(fetchRegionProjectListing.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        //Reducer for fetch Allocation Summary
                        .addCase(fetchRegionAllocationSummary.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(fetchRegionAllocationSummary.fulfilled, (state, action) => {
                                state.allocationSummary = action.payload.data;
                        })
                        .addCase(fetchRegionAllocationSummary.rejected, (state, action) => {
                                state.error = action.payload;
                        })

                        //Reducer for fetch Milestone Summary
                        .addCase(fetchRegionMilestoneSummary.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(fetchRegionMilestoneSummary.fulfilled, (state, action) => {
                                state.milestoneSummary = action.payload.data;
                        })
                        .addCase(fetchRegionMilestoneSummary.rejected, (state, action) => {
                                state.error = action.payload;
                        })
                        // Reducer for fetch projects dates
                        .addCase(fetchRegionProjectDates.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(fetchRegionProjectDates.fulfilled, (state, action) => {
                                state.projectDates = action.payload.data;
                        })
                        .addCase(fetchRegionProjectDates.rejected, (state, action) => {
                                state.error = action.payload;
                        })

                        //Reducer for PMG
                        .addCase(uploadPmgProjectsBulk.pending, (state) => {
                                state.loading = true;
                        })
                        .addCase(uploadPmgProjectsBulk.fulfilled, (state) => {
                                state.loading = false;
                        })
                        .addCase(uploadPmgProjectsBulk.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchDownloadExcelForAdmin.pending, (state) => {
                                state.loading = true;
                        })
                        .addCase(fetchDownloadExcelForAdmin.fulfilled, (state) => {
                                state.loading = false;
                        })
                        .addCase(fetchDownloadExcelForAdmin.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for project summary
                        .addCase(fetchRegionProjectSummary.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchRegionProjectSummary.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectSummary = action.payload.data;
                        })
                        .addCase(fetchRegionProjectSummary.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(fetchRegionProjectSummaryVersioned.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchRegionProjectSummaryVersioned.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectSummaryVersioned = action.payload.data;
                        })
                        .addCase(fetchRegionProjectSummaryVersioned.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        // Reducer for fetch data from in flow cash data
                        .addCase(getCashInflowData.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getCashInflowData.fulfilled, (state, action) => {
                                state.loading = false;
                                state.cashInflowData = action.payload.data.cashInflow;
                        })
                        .addCase(getCashInflowData.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getCashInflowDataVersion.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getCashInflowDataVersion.fulfilled, (state, action) => {
                                state.loading = false;
                                state.cashInflowVersion = action.payload.data.cashInflow;
                        })
                        .addCase(getCashInflowDataVersion.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        // Reducer for fetch data from in flow cash data
                        .addCase(getCashOutflowData.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getCashOutflowData.fulfilled, (state, action) => {
                                state.loading = false;
                                state.cashOutflowData = action.payload.data.cashOutflow;
                        })
                        .addCase(getCashOutflowData.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getCashOutflowDataVersioned.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getCashOutflowDataVersioned.fulfilled, (state, action) => {
                                state.loading = false;
                                state.cashOutflowVersion = action.payload.data.cashOutflow;
                        })
                        .addCase(getCashOutflowDataVersioned.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        // Reducer for fetch projects dates
                        .addCase(getBillingCost.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getBillingCost.fulfilled, (state, action) => {
                                state.loading = false;
                                state.billingCost = action.payload.data.billing;
                                state.billingCostCompleteData = action.payload.data;
                        })
                        .addCase(getBillingCost.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getBillingCostVersioned.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getBillingCostVersioned.fulfilled, (state, action) => {
                                state.loading = false;
                                state.billingCostVersion = action.payload.data.billing;
                                state.billingCostCompleteDataVersion = action.payload.data;
                        })
                        .addCase(getBillingCostVersioned.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        // Reducer for download Excel
                        .addCase(fetchDownloadExcel.pending, (state) => {
                                state.loading = true;
                        })
                        .addCase(fetchDownloadExcel.fulfilled, (state) => {
                                state.loading = false;
                        })
                        .addCase(fetchDownloadExcel.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        // Reducer for download Excel
                        .addCase(uploadExcelData.pending, (state) => {
                                state.loading = true;
                        })
                        .addCase(uploadExcelData.fulfilled, (state) => {
                                state.loading = false;
                        })
                        .addCase(uploadExcelData.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        //  Reducer for fetch unit commercial options
                        .addCase(fetchUnitCommercialOptions.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(fetchUnitCommercialOptions.fulfilled, (state, action) => {
                                state.loading = false;
                                state.unitCommercialOption = action.payload.data;
                        })
                        .addCase(fetchUnitCommercialOptions.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching initial estimate

                        .addCase(getInitialEstimate.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getInitialEstimate.fulfilled, (state, action) => {
                                state.loading = false;
                                state.getInitialValue = action.payload.data;
                        })
                        .addCase(getInitialEstimate.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //update project table status
                        .addCase(checkTablesUploadStatus.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(checkTablesUploadStatus.fulfilled, (state, action) => {
                                state.uploadTablesStatus = action.payload.data;
                        })
                        .addCase(checkTablesUploadStatus.rejected, (state, action) => {
                                state.error = action.payload;
                        })

                        //Reducer for fetching profit loss

                        .addCase(getProfitLoss.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProfitLoss.fulfilled, (state, action) => {
                                state.loading = false;
                                state.profitLossData = action.payload.data;
                        })
                        .addCase(getProfitLoss.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getProfitLossVersion.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProfitLossVersion.fulfilled, (state, action) => {
                                state.loading = false;
                                state.profitLossVersion = action.payload.data;
                        })
                        .addCase(getProfitLossVersion.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching project cost
                        .addCase(getProjectCost.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProjectCost.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectCostData = action.payload.data?.projectCost;
                                state.projectCostCompleteData = action.payload.data;
                        })
                        .addCase(getProjectCost.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getProjectCostVersion.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProjectCostVersion.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectCostVersion = action.payload.data?.projectCost;
                                state.projectCostCompleteVersion = action.payload.data;
                        })
                        .addCase(getProjectCostVersion.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching project cost
                        .addCase(getApportionedCost.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getApportionedCost.fulfilled, (state, action) => {
                                state.loading = false;
                                state.apportionedCostCompleteData = action.payload?.data;
                                state.apportionedCostData = action.payload.data?.aportionCost;
                        })
                        .addCase(getApportionedCost.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getApportionedCostVersioned.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getApportionedCostVersioned.fulfilled, (state, action) => {
                                state.loading = false;
                                state.apportionedCompleteVersion = action.payload?.data;
                                state.apportionedCostVersion = action.payload.data?.aportionCost;
                        })
                        .addCase(getApportionedCostVersioned.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching project revenue
                        .addCase(getProjectRevenue.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProjectRevenue.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectRevenueData = action.payload?.data;
                        })
                        .addCase(getProjectRevenue.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getProjectRevenueVersion.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getProjectRevenueVersion.fulfilled, (state, action) => {
                                state.loading = false;
                                state.projectRevenueVersion = action.payload?.data;
                        })
                        .addCase(getProjectRevenueVersion.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching project cost
                        .addCase(getOperationalIncome.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperationalIncome.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operationalIncomeData = action.payload.data?.operationalIncome;
                        })
                        .addCase(getOperationalIncome.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })
                        .addCase(getOperationalIncomeVersioned.pending, (state) => {
                                state.loading = true;
                                state.error = null;
                        })
                        .addCase(getOperationalIncomeVersioned.fulfilled, (state, action) => {
                                state.loading = false;
                                state.operationalIncomeVersion = action.payload.data?.operationalIncome;
                        })
                        .addCase(getOperationalIncomeVersioned.rejected, (state, action) => {
                                state.loading = false;
                                state.error = action.payload;
                        })

                        //Reducer for fetching card data
                        .addCase(getCustomCardDetail.pending, (state) => {
                                state.error = null;
                                state.cardDataLoading = true;
                        })
                        .addCase(getCustomCardDetail.fulfilled, (state, action) => {
                                state.cardData = action.payload.data;
                                state.cardDataLoading = false;
                        })
                        .addCase(getCustomCardDetail.rejected, (state, action) => {
                                state.error = action.payload;
                                state.cardDataLoading = false;
                        })
                        .addCase(getCustomCardDetailVersion.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(getCustomCardDetailVersion.fulfilled, (state, action) => {
                                state.cardDataVersion = action.payload.data;
                        })
                        .addCase(getCustomCardDetailVersion.rejected, (state, action) => {
                                state.error = action.payload;
                        })

                        .addCase(getOtherFlowsCustomCardDetail.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(getOtherFlowsCustomCardDetail.fulfilled, (state, action) => {
                                state.cardData = action.payload.data;
                        })
                        .addCase(getOtherFlowsCustomCardDetail.rejected, (state, action) => {
                                state.error = action.payload;
                        })
                        .addCase(getOtherFlowsCustomCardDetailVersioned.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(getOtherFlowsCustomCardDetailVersioned.fulfilled, (state, action) => {
                                state.cardVersionData = action.payload.data;
                        })
                        .addCase(getOtherFlowsCustomCardDetailVersioned.rejected, (state, action) => {
                                state.error = action.payload;
                        })

                        .addCase(getFinalSubmissionStatus.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(getFinalSubmissionStatus.fulfilled, (state, action) => {
                                state.finalSubmissionStatus = action.payload.data;
                        })
                        .addCase(getFinalSubmissionStatus.rejected, (state, action) => {
                                state.error = action.payload;
                        })
                        .addCase(getProjectStatus.pending, (state) => {
                                state.error = null;
                        })
                        .addCase(getProjectStatus.fulfilled, (state, action) => {
                                state.projectStatus = action.payload.data;
                        })
                        .addCase(getProjectStatus.rejected, (state, action) => {
                                state.error = action.payload;
                        })
                        .addCase(getExtendedProjectListing.pending, (state) => {
                                state.error = null;
                                state.loading = true;
                        })
                        .addCase(getExtendedProjectListing.fulfilled, (state, action) => {
                                state.extendedProjectListing = action.payload.data;
                                state.loading = false;
                        })
                        .addCase(getExtendedProjectListing.rejected, (state, action) => {
                                state.error = action.payload;
                                state.loading = false;
                        });
        },
});

export const { setActiveStep, setRevNumber, setIoNumber, clearProjectDates, setDisableProceed } = budgetSlice.actions;
export default budgetSlice.reducer;
